import React from 'react';
import Svg, { SvgProps, G, Path } from 'react-native-svg';

export const SvgTakeaway = ({ strokePath, ...props }: SvgProps) => (
  <Svg viewBox="0 0 32 32" width={'100%'} height={'100%'} {...props}>
    <G fill="none" fillRule="evenodd">
      <Path d="M0 0h32v32H0z" />
      <Path
        fill={strokePath}
        d="M28,10h-4V8c0-4.418-3.582-8-8-8c-4.418,0-8,3.582-8,8v2H4c-1.1,0-2,0.9-2,2v12c0,4.4,3.6,8,8,8h12c4.4,0,8-3.6,8-8V12  C30,10.9,29.1,10,28,10z M12,8c0-2.209,1.791-4,4-4s4,1.791,4,4v2h-8V8z M26,24c0,2.206-1.795,4-4,4H10c-2.206,0-4-1.794-4-4V14h2v2  c0,1.104,0.896,2,2,2s2-0.896,2-2v-2h8v2c0,1.104,0.896,2,2,2s2-0.896,2-2v-2h2V24z"
      />
    </G>
  </Svg>
);
